import BootstrapDialog from '@/components/Dialog/BootstrapDialog';
import { GenerateAvatar } from '@/pages/avatar';
import { useAvatarListPageContext } from '@/pages/avatar/ListPage/contex';
import theme from '@/theme';
import styled from '@emotion/styled';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

const ModalContent = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px;
`;

const DialogHeader = styled.div`
    display: flex;
    justify-content: space-between;

    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.48px;
`;

const StyledIconButton = styled(IconButton)`
    color: ${theme.colors.secondary[900]};
`;

export const GenerateAvatarModal = () => {
    const { generateModalOpen, setGenerateModalOpen } = useAvatarListPageContext();

    const handleClose = () => {
        setGenerateModalOpen(false);
    };

    return (
        <BootstrapDialog open={generateModalOpen} onClose={handleClose} width="646px">
            <ModalContent>
                <DialogHeader>
                    Generate Avatar
                    <StyledIconButton aria-label="close" onClick={handleClose}>
                        <CloseIcon fontSize="large" />
                    </StyledIconButton>
                </DialogHeader>

                <GenerateAvatar from="avatar" />
            </ModalContent>
        </BootstrapDialog>
    );
};
